import amms from '../../shared/assets/icons/aams-icon-svg';
import over18 from '../../shared/assets/icons/over-18-icon-svg';
import amd from '../../shared/assets/icons/amd-icon-svg';
import gioco from '../../shared/assets/icons/gioco-responsabile-icon-svg';

type DisclaimerParams = {
  repub?: string;
};

export type DisclaimerPayload = {
  notice: string;
  icons: string;
  poweredby: boolean;
};

export default ({ repub }: DisclaimerParams): DisclaimerPayload | undefined => {
  const normalisedRepub = repub?.toLowerCase();
  if (normalisedRepub === 'it')
    return {
      notice:
        'Gioco vietato ai minori. Può causare dipendenza patologica. Percentuali di vincita su ADM e siti operatori. Le quote reindirizzano a Oddschecker per possibile accesso ai siti operatori (verifica art. 5.6 delle Linee Guida di cui alla Legge 96/2018).',
      icons: `
        ${over18}
        ${amms}
        ${amd}
        ${gioco}
      `,
      poweredby: true
    };
};
